var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.6801 25.9774V30.4774C33.6818 30.8951 33.5962 31.3086 33.4288 31.6914C33.2615 32.0742 33.016 32.4178 32.7082 32.7002C32.4004 32.9826 32.0369 33.1976 31.6412 33.3314C31.2455 33.4653 30.8261 33.515 30.4101 33.4774C25.7943 32.9758 21.3606 31.3986 17.4651 28.8724C13.8408 26.5694 10.7681 23.4966 8.46508 19.8724C5.93004 15.9592 4.35244 11.5039 3.86008 6.86737C3.82259 6.45257 3.87189 6.03451 4.00483 5.63981C4.13776 5.24511 4.35143 4.88241 4.63222 4.57481C4.91302 4.2672 5.25478 4.02144 5.63576 3.85316C6.01674 3.68488 6.42859 3.59777 6.84508 3.59737H11.3451C12.073 3.59021 12.7788 3.84799 13.3307 4.32267C13.8827 4.79735 14.2432 5.45654 14.3451 6.17737C14.535 7.61747 14.8873 9.03146 15.3951 10.3924C15.5969 10.9293 15.6406 11.5127 15.5209 12.0737C15.4013 12.6346 15.1234 13.1495 14.7201 13.5574L12.8151 15.4624C14.9504 19.2177 18.0598 22.327 21.8151 24.4624L23.7201 22.5574C24.1279 22.1541 24.6428 21.8761 25.2038 21.7565C25.7647 21.6369 26.3482 21.6806 26.8851 21.8824C28.246 22.3902 29.66 22.7424 31.1001 22.9324C31.8287 23.0352 32.4942 23.4022 32.9699 23.9636C33.4456 24.5251 33.6983 25.2417 33.6801 25.9774Z",
    stroke: "#3EBC4B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.54362c48dae7e151ab333bedc6f8bf50.svg";
export { ForwardRef as ReactComponent };